import UrlUtils from '@spothero/utils/url';
import SearchAPI from 'api/search';
import { createCleanedData } from 'router/router-utils';
import { normalizeAddressParamData } from './normalize-address-param-data';
import appleInitialStateValidations from './apple-validations';
import { toSearchString } from './types';
export const getAddressData = async ({ pathname, query, currentCity, currentSearchState, }) => {
    const search = toSearchString(query);
    appleInitialStateValidations(search);
    const urlParams = UrlUtils.parseParams(search);
    const { data: { data: cleanedParams }, } = await SearchAPI.cleanParams({
        url: search ? `${pathname}?${search}` : pathname,
    });
    const normalizedUrlParams = normalizeAddressParamData(urlParams);
    return createCleanedData({
        currentCity,
        // Keep normalizedUrlParams last as they correct starts/ends (and related
        // power-booking fields) that the Search-Params response gets wrong.
        cleanedParams: { ...cleanedParams, ...normalizedUrlParams },
        currentSearchState,
    });
};
